import moment from 'moment';
import React from "react";
import { Row, Typography, DatePicker, Checkbox } from "antd";
import { dateFormat, EmployeeFollowUpEventQuizStatus, AnsweredBy, QuizAnsweredBy, NotApplicableSuffix, NotApplicableLabel } from "../common/GeneralConfigurations";
import './EmployeeFollowUpEventDetailListForm.css';
import AdnTextArea from '../common/adnTextArea/AdnTextArea';

const { Text, Title } = Typography;

const QuizQuestionDateForm = ({
    quizIsAnsweredBy,
    quizStatusId,
    readonly,
    answeredBy,
    questionText,
    isRequired,
    allowNotApplicable,
    errorMessage,
    onNotApplicable,
    isReadOnly,
    fieldName,
    consultantAnswer,
    consultantAllowNotApplicableAnswer,
    supervisorAnswer,
    supervisorAllowNotApplicableAnswer,
    handleDateChange,
    onBlur,
}) => {

    const isNotApplicable = true;

    return (
        <>
            {/* Consultant view or Supervisor view and wating for consultant answer */}
            {quizStatusId === EmployeeFollowUpEventQuizStatus.AwaitsResponseFromConsultant &&
                (answeredBy === AnsweredBy.Consultant || answeredBy === AnsweredBy.Both) &&
                <div className="quiz-question-person">
                    {/* <p>{fieldName} required: {isRequired} allowNotApplicable:{allowNotApplicable} supervisorAnswer:{supervisorAnswer}</p> */}
                    <Row className="question-title">
                        <Text type="danger">{isRequired ? "* " : ""}</Text>
                        <AdnTextArea
                            placeholder={questionText}
                            disabled
                            autoSize
                        />
                    </Row>
                    <p className="quiz-element-margin">
                        <DatePicker
                            name={fieldName}
                            format={dateFormat}
                            disabled={isReadOnly(allowNotApplicable === true ? consultantAllowNotApplicableAnswer : false)}
                            className="quiz-datepicker"
                            value={supervisorAnswer != undefined ? moment(supervisorAnswer, dateFormat) : undefined}
                            defaultValue={supervisorAnswer != undefined ? moment(consultantAnswer, dateFormat) : undefined}
                            onChange={e => handleDateChange(e, fieldName)}
                        /></p>
                    {allowNotApplicable === true &&
                        <p className="quiz-element-margin">
                            <Checkbox
                                name={fieldName + NotApplicableSuffix}
                                defaultChecked={consultantAllowNotApplicableAnswer}
                                checked={consultantAllowNotApplicableAnswer}
                                onChange={(value) => onNotApplicable(value, fieldName)}
                                disabled={readonly}>
                                {NotApplicableLabel}
                            </Checkbox></p>
                    }
                    {errorMessage && <Text type="danger">{errorMessage}</Text>}
                </div>
            }
            {/* Supervisor view for regular type events, that are answered only by the supervisor */}
            {quizIsAnsweredBy === QuizAnsweredBy.Supervisor && quizStatusId === EmployeeFollowUpEventQuizStatus.AwaitsResponseFromSupervisor &&
                (answeredBy === AnsweredBy.Supervisor || answeredBy === AnsweredBy.Both) &&
                <>
                    {/* <p>{fieldName} required: {isRequired} allowNotApplicable:{allowNotApplicable} supervisorAnswer:{supervisorAnswer}</p> */}
                    <Row className="question-title">
                        <Text type="danger">{isRequired ? "* " : ""}</Text>
                        <AdnTextArea
                            placeholder={questionText}
                            disabled
                            autoSize
                        />
                    </Row>
                    <p className="quiz-element-margin">
                        <DatePicker
                            name={fieldName}
                            format={dateFormat}
                            disabled={isReadOnly(allowNotApplicable === true ? supervisorAllowNotApplicableAnswer : false)}
                            className="quiz-datepicker"
                            value={supervisorAnswer != undefined ? moment(supervisorAnswer, dateFormat) : undefined}
                            defaultValue={supervisorAnswer != undefined ? moment(supervisorAnswer, dateFormat) : undefined}
                            onChange={e => handleDateChange(e, fieldName)}
                        /></p>
                    {allowNotApplicable === true &&
                        <p className="quiz-element-margin">
                            <Checkbox
                                name={fieldName + NotApplicableSuffix}
                                defaultChecked={supervisorAllowNotApplicableAnswer}
                                checked={supervisorAllowNotApplicableAnswer}
                                onChange={(value) => onNotApplicable(value, fieldName)}
                                disabled={readonly}>
                                {NotApplicableLabel}
                            </Checkbox></p>
                    }
                    {errorMessage && <Text type="danger">{errorMessage}</Text>}
                </>
            }
            {/* Supervisor view for evaluation type events */}
            {quizIsAnsweredBy === QuizAnsweredBy.Consultant && quizStatusId === EmployeeFollowUpEventQuizStatus.AwaitsResponseFromSupervisor &&
                <>
                    {/* consultant answer */}
                    {(answeredBy === AnsweredBy.Consultant || answeredBy === AnsweredBy.Both) &&
                        <>
                            <Row className="question-title">
                                <Text type="danger">{isRequired ? "* " : ""}</Text>
                                <AdnTextArea
                                    placeholder={questionText}
                                    disabled
                                    autoSize
                                />
                            </Row>
                            {allowNotApplicable === true &&
                                consultantAllowNotApplicableAnswer === isNotApplicable ? (
                                <>
                                    <b style={{ color: "var(--adnblue)" }}>Consultant:</b>{" "}
                                    <p className="quiz-not-applicable">{NotApplicableLabel}</p>
                                </>
                            ) : (
                                <p>
                                    <b style={{ color: "var(--adnblue)" }}>Consultant:</b>{" "}
                                    {consultantAnswer}
                                </p>
                            )}
                        </>
                    }
                    {/* supervisor answer */}
                    {(answeredBy === AnsweredBy.Supervisor || answeredBy === AnsweredBy.Both) &&
                        <div className='quiz-question-person'>
                            <Row className="question-title">
                                <Text type="danger">{isRequired ? "* " : ""}</Text>
                                <AdnTextArea
                                    placeholder={questionText}
                                    disabled
                                    autoSize
                                />
                            </Row>
                            <p className="quiz-element-margin">
                                <DatePicker
                                    name={fieldName}
                                    format={dateFormat}
                                    disabled={isReadOnly(allowNotApplicable === true ? supervisorAllowNotApplicableAnswer : false)}
                                    className="quiz-datepicker"
                                    value={supervisorAnswer != undefined ? moment(supervisorAnswer, dateFormat) : undefined}
                                    defaultValue={supervisorAnswer != undefined ? moment(supervisorAnswer, dateFormat) : undefined}
                                    onChange={e => handleDateChange(e, fieldName)}
                                    onBlur={onBlur}
                                    allowClear={false}
                                /></p>
                            {allowNotApplicable === true &&
                                <p className="quiz-element-margin">
                                    <Checkbox
                                        name={fieldName + NotApplicableSuffix}
                                        defaultChecked={supervisorAllowNotApplicableAnswer}
                                        checked={supervisorAllowNotApplicableAnswer}
                                        onChange={(value) => onNotApplicable(value, fieldName)}
                                        disabled={readonly}>
                                        {NotApplicableLabel}
                                    </Checkbox></p>
                            }
                            {errorMessage && <Text type="danger">{errorMessage}</Text>}
                        </div>
                    }
                </>
            }
            {/* when quiz is answered */}
            {quizStatusId === EmployeeFollowUpEventQuizStatus.Answered &&
                <>
                    {/* consultant answer */}
                    <Row className="question-title">
                        <Text type="danger">{isRequired ? "* " : ""}</Text>
                        <AdnTextArea
                            placeholder={questionText}
                            disabled
                            autoSize
                        />
                    </Row>
                    {(consultantAnswer || consultantAllowNotApplicableAnswer) &&
                        <p>
                            <span code strong className="answer-consultant">Consultant: </span>
                            {consultantAnswer &&
                                <Text>{consultantAnswer}</Text>}
                            {consultantAllowNotApplicableAnswer === isNotApplicable &&
                                <Text type="warning" className='quiz-not-applicable'>{NotApplicableLabel}</Text>}
                        </p>
                    }
                    {/* supervisor answer */}
                    {(supervisorAnswer || supervisorAllowNotApplicableAnswer) &&
                        <p>
                            <span className="answer-supervisor">Supervisor: </span>
                            {supervisorAnswer &&
                                <Text>{supervisorAnswer}</Text>}
                            {supervisorAllowNotApplicableAnswer === isNotApplicable &&
                                <Text type="warning" className='quiz-not-applicable'>{NotApplicableLabel}</Text>}
                        </p>
                    }
                </>
            }
        </>
    );
};

export default QuizQuestionDateForm;